import { Box, Collapse, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import { useLoading } from "../../../components/Loading/useLoading";
import React, { useContext, useState } from "react";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { ThemeContext } from "@emotion/react";
import { exportToExcel } from "react-json-to-excel";
import { GetReporteCuarentena } from "../../../hooks/reporteDefectivos";
import { CuarentenaFiltros } from "./components/CuarentenaFiltros";
import moment from "moment";

export const ReporteCuarentenaIndex = () => {

  const theme = useContext(ThemeContext);
  const { setAppLoading } = useLoading();
  const { getReporteCuarentenaMutation } = GetReporteCuarentena();
  const [dataLogistica, setDataLogistica] = useState([]);


  const search = (body) => {
    setAppLoading(true)
    getReporteCuarentenaMutation(body, {
      onSuccess: (data) => {
        console.log(data);
        setDataLogistica(data);
      },
      onError: (error) => {
        console.log(error);
        setDataLogistica([]);
      },
      onSettled: () => {
        setAppLoading(false);
      }
    })
  }

  function ThirdRow(props) {
    const { row } = props;

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.serial}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.etiqueta}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.orden}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.cantidad}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {moment(row?.fecha)?.format('DD-MM-YYYY')}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.usuario}
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  function SecondRow(props) {
    const { row } = props;
    const [open, setOpen] = useState(false);

    const open_subtabla = () => {
      if (open) {
        setOpen(!open);
      } else {
        setOpen(!open);
      }
    };

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell sx={{ p: 0.5 }}>
            <IconButton
              aria-label="expand row"
              size="small"
              style={{ width: 25 }}
              onClick={() => open_subtabla()}
            >
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.defectivo}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.almacen}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.cantidad}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Serial
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Etiqueta
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Orden compra
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Cantidad
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Fecha
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Usuario
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row?.movimientos?.map((secRow, index) => (
                      <ThirdRow key={`movimiento-${secRow?.etiqueta}_${index}`} row={secRow} />
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = useState(false);

    const open_subtabla = () => {
      if (open) {
        setOpen(!open);
      } else {
        setOpen(!open);
      }
    };

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell sx={{ p: 0.5 }}>
            <IconButton
              aria-label="expand row"
              size="small"
              style={{ width: 25 }}
              onClick={() => open_subtabla()}
            >
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.part_nombre}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.part_codigoentrada}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.codigo_empresa}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.empresa}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5
            }}
          >
            {row?.cantidad}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" sx={{ color: "white" }} />
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Defectivo
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Almacen proveniente
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Cantidad
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row?.defectos?.map((secRow, index) => (
                      <SecondRow key={`parte_${row?.part_id}_defecto-${index}`} row={secRow} />
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const exportToExcelGeneral = () => {

    let data = dataLogistica.map((item) => item?.defectos).flat().map((defecto) => defecto?.movimientos).flat().map((movimiento) => movimiento);
    console.log(data);
    exportToExcel(
      data,
      `galus_reporte_defectivos_${moment().format('YYYYMMDDHHmm')}`
    )
  }

  return (
    <Grid container spacing={0} sx={{ height: '87vh', alignContent: 'flex-start', overflowY: 'auto' }}>
      <Grid item xs={12} sx={{ padding: '10px 20px', flexDirection: 'column', justifyContent: 'flex-start' }} className="center_item">
        <CuarentenaFiltros key='filtros_r_turno' searchData={search} exportGeneral={exportToExcelGeneral} canDownXlsx={dataLogistica?.length > 0} />
      </Grid>
      <Grid item xs={12} sx={{ padding: '10px 20px', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start' }} className="center_item">
        {
          dataLogistica.length > 0 &&
          <Paper
            style={{ maxHeight: '100vh', overflowY: "scroll", width: "100%" }}
            sx={{ boxShadow: "none" }}
          >
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead
                  sx={{
                    display: "table-head",
                    backgroundColor: theme.palette.primary.main,
                    fontWeight: 600,
                  }}
                >
                  <TableRow>
                    <TableCell align="center" sx={{ color: "white" }} />
                    <TableCell align="center" sx={{ color: "white" }}>
                      Parte
                    </TableCell>
                    <TableCell align="center" sx={{ color: "white" }}>
                      Código entrada
                    </TableCell>
                    <TableCell align="center" sx={{ color: "white" }}>
                      Código Cliente
                    </TableCell>
                    <TableCell align="center" sx={{ color: "white" }}>
                      Cliente
                    </TableCell>
                    <TableCell align="center" sx={{ color: "white" }}>
                      Cantidad
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataLogistica?.map((row, index) => (
                    <Row key={index} row={row} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        }
      </Grid>
    </Grid>
  )
}